import api from '@edu-fe/api'

const module = {
  name: 'privilege',

  getPrivilegeInfo: (version = 1) => api.create(`/vip/detail?version=${version}`),

  getPrivilegeDetail: api.create('/vip/detail/list'),
  signWX: (from) => {
    return api.create(`/wx/sign?from=${from}`, {
      method: 'post'
    })
  },
  getCourses: api.create('/operation/popular/course')
}

export default module
